import script from "./AbitSwitch.vue?vue&type=script&lang=ts&setup=true"
export * from "./AbitSwitch.vue?vue&type=script&lang=ts&setup=true"

import "./AbitSwitch.vue?vue&type=style&index=0&id=d35de3b8&scoped=true&lang=css"

import exportComponent from "/home/francesco/opt/quired/abit/resources/js/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d35de3b8"]])

export default __exports__